import { useEffect, useState } from 'react'
import { audiences, navigation, planes } from './content.js'
import { Demo } from './Demo.jsx'
import { Hero } from './Hero.jsx'
import { Products } from './Products.jsx'
import { SystemLoop } from './SystemLoop.jsx'
import { ArrowIcon, Brand } from './ui.jsx'

function Header() {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header className={`site-header${scrolled ? ' is-scrolled' : ''}`}>
      <div className="shell header-inner">
        <Brand />
        <nav className="desktop-nav" aria-label="Primary navigation">
          {navigation.map((item) => (
            <a href={item.href} key={item.href}>{item.label}</a>
          ))}
        </nav>
        <a className="button button-light header-cta" href="#demo">Book a demo <ArrowIcon /></a>
        <button
          className="menu-button"
          type="button"
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen((value) => !value)}
        >
          <span className="sr-only">Toggle navigation</span>
          <span /><span />
        </button>
      </div>
      <nav className="mobile-nav" id="mobile-navigation" aria-label="Mobile navigation" hidden={!open}>
        {navigation.map((item) => (
          <a href={item.href} key={item.href} onClick={() => setOpen(false)}>{item.label}</a>
        ))}
        <a href="#demo" onClick={() => setOpen(false)}>Book a demo</a>
      </nav>
    </header>
  )
}

function Architecture() {
  return (
    <section className="architecture section" id="architecture">
      <div className="shell">
        <div className="architecture-title">
          <p className="eyebrow">Architecture</p>
          <h2>Mostly software.<br />A hard settlement kernel.</h2>
          <p>Only the truths that counterparties must independently trust belong on-chain. The rest stays fast, adaptable, and operable.</p>
        </div>
        <div className="plane-list">
          {planes.map((plane, index) => (
            <article className="plane" key={plane.key}>
              <span className="plane-index">0{index + 1}</span>
              <div><h3>{plane.name}</h3><p>{plane.summary}</p></div>
              <span className={`chain-status status-${plane.chain.toLowerCase()}`}>CHAIN / {plane.chain}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

function Solutions() {
  return (
    <section className="solutions section" id="solutions">
      <div className="shell">
        <div className="section-intro compact">
          <p className="eyebrow dark">Two sides of the same rail</p>
          <h2>Built equally for agents and institutions.</h2>
        </div>
        <div className="audience-grid">
          {audiences.map((audience, index) => (
            <article className="audience-card" key={audience.key}>
              <span className="audience-number">0{index + 1}</span>
              <p className="eyebrow dark">{audience.label}</p>
              <h3>{audience.title}</h3>
              <p>{audience.summary}</p>
              <a className="quiet-link dark" href="#demo">See the workflow <ArrowIcon /></a>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <Brand />
        <p>Settlement infrastructure for agent commerce and institutional money.</p>
        <div className="footer-links">
          <a href="#products">Platform</a><a href="#architecture">Architecture</a><a href="#demo">Book a demo</a>
        </div>
        <span className="copyright">© {new Date().getFullYear()} SettlementOS</span>
      </div>
    </footer>
  )
}

export default function App() {
  return (
    <>
      <a className="skip-link" href="#main">Skip to content</a>
      <Header />
      <main id="main" tabIndex="-1">
        <Hero />
        <Products />
        <Architecture />
        <Solutions />
        <SystemLoop />
        <Demo />
      </main>
      <Footer />
    </>
  )
}
